export enum QueueStatusEnum {
    naoAtendido = 1,
    evadido = 2,
    atendido = 4,
    chamando = 5,
    emAtendimento = 6,
    retorno = 7,
}